import React, { Fragment } from "react";
import { Chip, CircularProgress, Grid, IconButton, makeStyles, Paper, Typography } from "@material-ui/core";
import { Delete, Edit, Person, SupervisorAccount } from "@material-ui/icons";
import { selectUser } from "../../features/data/user/userSlice";
import { useSelector, shallowEqual } from "react-redux";

const useStyles = makeStyles(() => ({
  messageOwnerText: {
    fontWeight: "bold",
    marginLeft: 10,
  },
  messageText: {
    padding: 10,
    // color: "#424242",
    textAlign: "justify",
    whiteSpace: "pre-wrap",
  },
  messagePaper: {
    padding: 10,
    marginBottom: 10,
  },
}));

const MessageCard = (props) => {
  const classes = useStyles();
  const { deleteMessage, editMessage, message } = props;
  const { user } = useSelector(selectUser, shallowEqual);

  const date = new Date(message.created_at);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  return (
    <Grid item xs={12}>
      <Paper className={classes.messagePaper}>
        <Grid container direction='row' alignItems='center'>
          <Typography variant='h5' className={classes.messageOwnerText}>
            {(message.user.first_name + " " + message.user.last_name)?.toString()?.toPersianDigits()}
          </Typography>
          <Chip
            color='secondary'
            icon={message.user.role === "admin" ? <SupervisorAccount /> : <Person />}
            label={message.user.role === "admin" ? "مدیر" : "کاربر"}
            size='small'
            style={{ marginRight: 10 }}
          />

          {date.getTime() < today.getTime() && date.getTime() >= yesterday.getTime() && (
            <Chip size='small' label='جدید' style={{ marginRight: 10 }} />
          )}
          <div style={{ flexGrow: 1 }} />
          {user && (user.id === message.user.id || user.role === "admin") && (
            <Fragment>
              <IconButton onClick={() => editMessage(message?.id, message?.text)}>
                <Edit />
              </IconButton>
              <IconButton onClick={() => deleteMessage(message.id)}>
                <Delete />
              </IconButton>
            </Fragment>
          )}
        </Grid>
        <Typography variant='body2' color='textSecondary' className={classes.messageText}>
          {message.text?.toString()?.toPersianDigits()}
        </Typography>
      </Paper>
    </Grid>
  );
};

export default MessageCard;
